import { useSyncExternalStore } from 'react'
import { Bell } from 'lucide-react'
import { Button, Card, CardBody } from '@najah/ui'
import { disablePush, enablePush, getPushState, subscribePush, supportsPush } from '../lib/pushClient'

export function PushSettings() {
  const state = useSyncExternalStore(subscribePush, getPushState)
  if (!supportsPush) return null
  return <Card><CardBody className="space-y-3">
    <div className="flex items-center gap-2 font-semibold"><Bell className="size-5 text-primary" />إشعارات الطلبات</div>
    <p className="text-sm text-fg-muted">تلقَّ إشعاراً عند تأكيد طلبك أو تجهيزه أو خروجه للتوصيل.</p>
    {state.error && <p role="alert" className="text-sm text-danger">{state.error}</p>}
    <Button variant="secondary" loading={state.busy} onClick={() => void (state.enabled ? disablePush() : enablePush())}>
      {state.enabled ? 'إيقاف الإشعارات' : 'تفعيل الإشعارات'}
    </Button>
  </CardBody></Card>
}
